import apiClient from './apiClient';

export interface Theme {
  id: string;
  label: string;
  identifier: string;
  description: string | null;
  sessionCount: number;
  sports: string[];
}

export interface ThemePayload {
  label: string;
  identifier: string;
  description?: string | null;
  sports: string[];
}

export interface ThemeList {
  items: Theme[];
  total: number;
}

export const getThemes = async (filters: { search?: string; page?: number; pageSize?: number }): Promise<ThemeList> => {
  const response = await apiClient.get('admin/themes', { params: filters });
  return response.data as ThemeList;
};

export const createTheme = async (payload: ThemePayload): Promise<Theme> => {
  const response = await apiClient.post('admin/themes', payload);
  return response.data as Theme;
};

export const updateTheme = async (id: string, payload: ThemePayload): Promise<Theme> => {
  const response = await apiClient.put(`admin/themes/${id}`, payload);
  return response.data as Theme;
};

export const deleteTheme = async (id: string): Promise<void> => {
  await apiClient.delete(`admin/themes/${id}`);
};

export interface ThemeImportRow {
  label: string;
  identifier?: string;
  description?: string | null;
  sports: string[];
}

export interface ThemeImportReportRow {
  index: number;
  label: string;
  identifier: string;
  sports: string[];
  status: 'ok' | 'error';
  action?: 'create' | 'update';
  reason?: string;
}

export interface ThemeImportReport {
  dryRun: boolean;
  summary: { total: number; resolved: number; unresolved: number; created: number; updated: number; imported: number };
  rows: ThemeImportReportRow[];
}

export const importThemes = async (rows: ThemeImportRow[], dryRun: boolean): Promise<ThemeImportReport> => {
  const response = await apiClient.post('admin/themes/import', { rows, dryRun });
  return response.data as ThemeImportReport;
};
